// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Rtyr-","carouselItem":"_7MMs5","button":"FbEV7","previousButton":"_35Glo","nextButton":"NVKAv","buttonAutoPlay":"_1nlRF","controls":"pKL5W","bullets":"_3mOUr"};